import React, { FC, PropsWithChildren, ReactNode, useEffect } from 'react';
import { useLegoland } from '../LegolandContext';
import { useMeQuery } from './authApiHooks';
import { UserRole } from './authApiTypes';

export interface RequireAuthProps {
  autoRedirect?: boolean;
  fallback?: ReactNode;
  role?: UserRole | UserRole[];
}

export const RequireAuth: FC<PropsWithChildren<RequireAuthProps>> = ({
  autoRedirect = false,
  children,
  fallback = null,
  role,
}) => {
  if (typeof role === 'string') {
    role = [role];
  }

  const { legolandUiUrl } = useLegoland();
  const { data, isSuccess } = useMeQuery();

  useEffect(
    function onAuthStateChangeEffect() {
      if (autoRedirect && isSuccess && data!.me === null) {
        window.location.assign(
          `${legolandUiUrl}/login?redirect=${encodeURIComponent(
            window.location.toString(),
          )}`,
        );
      }
    },
    [autoRedirect, isSuccess, data],
  );

  if (!isSuccess) {
    return null;
  }

  const isAuthenticated = Boolean(data!.me);

  if (!isAuthenticated && autoRedirect) {
    return null; // Do not render anything, because user will be redirected anyway.
  }

  const hasValidRole =
    isAuthenticated && (!role || role.includes(data!.me!.role));

  if (!hasValidRole) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
};
